const tecnologiesList = [
    {
        id: '1',
        img: 'img/html.png',
        alt: 'ícone html',
        name: 'HTML5'
    },
    {
        id: '2',
        img: 'img/css.png',
        alt: 'ícone css',
        name: 'CSS3'
    },
    {
        id: '3',
        img: 'img/js.png',
        alt: 'ícone javascript',
        name: 'JavaScript'
    },
    {
        id: '4',
        img: 'img/typescript.png',
        alt: 'ícone typescript',
        name: 'TypeScript'
    },
    {
        id: '5',
        img: 'img/angular.png',
        alt: 'ícone angular',
        name: 'Angular'
    },
    {
        id: '6',
        img: 'img/reactjs.png',
        alt: 'ícone reactjs',
        name: 'React JS'
    },
    {
        id: '7',
        img: 'img/vue.png',
        alt: 'ícone vue',
        name: 'Vue 3'
    },
    {
        id: '8',
        img: 'img/docker.png',
        alt: 'ícone docker',
        name: 'Docker'
    },
    {
        id: '9',
        img: 'img/php.png',
        alt: 'ícone php',
        name: 'PHP'
    },
    {
        id: '10',
        img: 'img/mysql.png',
        alt: 'ícone mysql',
        name: 'MySQL'
    },
    {
        id: '11',
        img: 'img/laravel.png',
        alt: 'ícone laravel',
        name: 'Laravel'
    }
];

export default tecnologiesList;